import { LoadableAfterPaint } from '@confluence/loadable';

export const DeepLinkHandler = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-DeepLinkHandler" */ './DeepLinkHandler.tsx'))
			.DeepLinkHandler,
});
